<ng-container *transloco="let t" anihisCloseOnEsc (escPressed)="closeDialog()">
  <div class="align-items-center" mat-dialog-title>
    <h2>{{ data.firstName + ' ' + data.lastName }}</h2>
    <div
      (click)="redirectToOwner(data.animal.animalUid, data.uid)" role="button" tabindex="0" (keydown.enter)="redirectToOwner(data.animal.animalUid, data.uid)" (keydown.space)="redirectToOwner(data.animal.animalUid, data.uid)"
      class="primary-btn cursor"
    >
      {{ t('Detail owner') }}
      <mat-icon class="preview-white-icon"></mat-icon>
    </div>
  </div>

  @if (data) {
    <div class="content">
      <mat-list>
        <!-- <mat-list-item>
        <p>{{ t('JMBG') }}</p>
        @if (data?.personalNumber) {
          <div class="flex gap-xs">
            <b>{{ data.personalNumber }}</b>
            <span
              class="help-icon cursor"
              matTooltipShowDelay="200"
              [matTooltip]="t('JMBG') + ': ' + data.personalNumber"
              matTooltipPosition="above"
            ></span>
          </div>
        } @else {
          <div
            class="flex items-center justify-center"
            style="width: 24px; height: 24px"
          >
            <span class="no-data">-</span>
          </div>
        }
      </mat-list-item>
      <mat-divider></mat-divider>

      <mat-list-item>
        <p>{{ t('ID Card Number') }}</p>
        @if (data?.idCardNumber) {
          <b>{{ data.idCardNumber }}</b>
        } @else {
          <div
            class="flex items-center justify-center"
            style="width: 24px; height: 24px"
          >
            <span class="no-data">-</span>
          </div>
        }
      </mat-list-item>
      <mat-divider></mat-divider>

      <mat-list-item>
        <p>{{ t('Passport Number') }}</p>
        @if (data?.passportNumber) {
          <b>{{ data.passportNumber }}</b>
        } @else {
          <div
            class="flex items-center justify-center"
            style="width: 24px; height: 24px"
          >
            <span class="no-data">-</span>
          </div>
        }
      </mat-list-item>
      <mat-divider></mat-divider> -->

        <mat-list-item>
          <p>{{ t('Address') }}</p>
          @if (
            data?.contact?.street &&
            data?.contact?.postalCode &&
            data?.contact?.city
          ) {
            <b>
              {{
                data.contact.street +
                  ', ' +
                  data.contact.postalCode +
                  ' ' +
                  data.contact.city
              }}
            </b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Phone number') }}</p>
          @if (data?.contact?.phoneNumber) {
            <b>{{ data.contact.phoneNumber }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Mobile Number') }}</p>
          @if (data?.contact?.mobileNumber) {
            <b>{{ data.contact.mobileNumber }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Email') }}</p>
          @if (data?.email) {
            <b>{{ data.email }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item>
          <p>{{ t('Discount') }}</p>
          @if (data?.discount) {
            <b>{{ data.discount }}</b>
          } @else {
            <div
              class="flex items-center justify-center"
              style="width: 24px; height: 24px"
            >
              <span class="no-data">-</span>
            </div>
          }
        </mat-list-item>
        <mat-divider></mat-divider>

        @if (data?.warning) {
          <div class="warning mt-4">
            <p>{{ t('Warning') + ':' }}</p>
            <div class="warning-text">
              <p>{{ data.warning }}</p>
            </div>
          </div>
        }
      </mat-list>
    </div>
    <mat-dialog-actions align="end">
      <button mat-stroked-button (click)="closeDialog()" class="secondary-btn">
        {{ t('Close') }}
      </button>
    </mat-dialog-actions>
  } @else {
    <div
      class="loading-container"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 200px;
      "
    >
      <mat-progress-spinner
        diameter="18"
        mode="indeterminate"
        strokeWidth="3"
      ></mat-progress-spinner>
    </div>
  }
</ng-container>
